export interface GridFit {
  columns: number
  cardWidth: number
  cardHeight: number
}

/**
 * Largest card of a fixed aspect ratio that lets `count` cards fit in the box.
 *
 * Returns null when the box has no area yet (before the first measurement).
 */
export function bestFitGrid(
  width: number,
  height: number,
  count: number,
  aspect: number,
  gap: number,
): GridFit | null {
  if (width <= 0 || height <= 0 || count <= 0) return null

  let best: GridFit | null = null
  for (let columns = 1; columns <= count; columns++) {
    const rows = Math.ceil(count / columns)
    const cellWidth = (width - gap * (columns - 1)) / columns
    const cellHeight = (height - gap * (rows - 1)) / rows
    if (cellWidth <= 0 || cellHeight <= 0) continue

    const cardWidth = Math.min(cellWidth, cellHeight * aspect)
    if (best === null || cardWidth > best.cardWidth) {
      best = { columns, cardWidth, cardHeight: cardWidth / aspect }
    }
  }
  return best
}
